import { render, staticRenderFns } from "./orders-bootstrap-table.vue?vue&type=template&id=3cf9b746"
import script from "./orders-bootstrap-table.vue?vue&type=script&lang=js"
export * from "./orders-bootstrap-table.vue?vue&type=script&lang=js"
import style0 from "./orders-bootstrap-table.vue?vue&type=style&index=0&id=3cf9b746&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports